<template>
	<v-dialog
		:value="value"
		persistent
		width="480px">
		<v-card>
			<v-card-title class="headline py-2 px-5">
				<v-layout row wrap align-center>
					<v-flex xs6 text-xs-left>
						<p class="headline-title">
							Anulación de reserva
						</p>
					</v-flex>
					<v-flex xs6 text-xs-right>
						<label class="headline-label">
							Fecha:
						</label>
						{{ today }}
					</v-flex>
				</v-layout>
			</v-card-title>
			<v-card-text class="px-5">
				<v-layout row wrap
					text-xs-left>
					<v-flex xs6>
						<label class="label-title">Motivo</label>
						<v-text-field
							class="input-border-inset"
							v-model="cancelModel.title">
						</v-text-field>
						<span class="caption red--text"
							v-if="$v.cancelModel.title && $v.cancelModel.title.$invalid">
							El motivo de anulación es requerido
						</span>
					</v-flex>
					<v-flex xs12 mt-3>
						<label class="label-title">Descripción</label>
						<v-text-field
							class="input-border-inset input-textarea input-note"
							no-resize
							multi-line
							:rows="3"
							textarea
							v-model="cancelModel.description"
						></v-text-field>
						<span class="caption red--text"
							v-if="$v.cancelModel.description && $v.cancelModel.description.$invalid">
							La descripción de la anulación es requerida
						</span>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-layout row wrap justify-center>
					<v-flex xs3 pr-2>
						<v-btn
							class="btn-cancel grey"
							@click.native="closeCancelModal">
							Cancelar
						</v-btn>
					</v-flex>
					<v-flex xs3 pl-2>
						<v-btn
							class="btn-save"
							:disabled="$v.$invalid"
							@click.native="cancelBooking">
							Aceptar
						</v-btn>
					</v-flex>
				</v-layout>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { format } from 'date-fns';
import mixin from '@/shared/mixins';

function closeCancelModal() {
	this.$emit('close-cancel-modal');
}

async function cancelBooking() {
	await this.$http.put(`${process.env.PMS_URL}/reserve/${this.bookingCode}`, this.cancelModel);
	this.showNotification('La reserva ha sido anulada correctamente.', 'success');
	this.$emit('updated-booking-status');
	this.closeCancelModal();
}

function validations() {
	return {
		cancelModel: {
			description: {
				required,
			},
			title: {
				required,
			},
		},
	};
}

function data() {
	return {
		cancelModel: {
			description: '',
			title: '',
		},
		today: format(new Date(), 'YYYY-MM-DD'),
	};
}

export default {
	name: 'menu-cancel-booking',
	data,
	methods: {
		cancelBooking,
		closeCancelModal,
	},
	mixins: mixin,
	props: {
		bookingCode: {
			default: '',
			type: String,
		},
		value: null,
	},
	validations,
};
</script>




// WEBPACK FOOTER //
// MenuCancelBooking.vue?88807604